/**
 * Agence'O - filters-trigger
 * @author Michael RFDSN (Agence'O)
 * @created 14/05/2019
 */

(function ($) {

  $('.js-tablist__tabs__link').click(function(event){
    event.preventDefault();
    var $el = $(this);
    var $parent = $el.closest('li');
    var $sibling_child = $parent.siblings().children('a').eq(0);
    var $el_id = $el.attr('href');

    if($el.hasClass('is-open')){ return false; }

    $el.addClass('is-open');
    $sibling_child.removeClass('is-open');

    $($el_id).addClass('is-open').siblings().removeClass('is-open');



  });


}(jQuery));
